export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_LOADING = 'SET_LOADING';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const GET_ACCOMMODATIONS = 'GET_ACCOMMODATIONS';
export const GET_ACCOMMODATION = 'GET_ACCOMMODATION';
export const FILTER_ROOMS_ACCOMM = 'FILTER_ROOMS_ACCOMM';
export const CLEAR_AVAIL_ROOMS = 'CLEAR_AVAIL_ROOMS';
export const BOOK_ACCOMM = 'BOOK_ACCOMM';
export const GET_PAYMENT_INFO = 'GET_PAYMENT_INFO';
export const SAVE_USER_BOOKING = 'SAVE_USER_BOOKING';

export const GET_TOURS = 'GET_TOURS';
export const GET_TOUR = 'GET_TOUR';
export const BOOK_TOUR = 'BOOK_TOUR';
export const GET_PAYMENT_INFO_TOUR = 'GET_PAYMENT_INFO_TOUR';

export const FILTER_ACCOMMODATIONS = 'FILTER_ACCOMMODATIONS';
export const FILTER_TOURS = 'FILTER_TOURS';
export const CLEAR_FILTER = 'CLEAR_FILTER';

export const GET_OWNER_SERVICES = 'GET_OWNER_SERVICES';
export const BLOCK_SERVICE_DATES = 'BLOCK_SERVICE_DATES';
export const UNBLOCK_DATE = 'UNBLOCK_DATE';

export const SEND_CONTACT = 'SEND_CONTACT';

export const CHRISTMAS_BOOKING = 'CHRISTMAS_BOOKING';

export const GET_TOURISTS_TERMS = 'GET_TOURISTS_TERMS';


// WEBPACK FOOTER //
// ./src/actions/types.js